
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est la technique utilisée?`}</em></p>
    <p>{`Celle de l’`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=gl3aY-9JtRw"
      }}>{`ARN messager`}</a>{` (ARNm),
qui n’avait encore jamais été employée. Dans cette méthode, le vaccin envoie des
instructions à nos cellules pour qu'elles produisent une protéine du
coronavirus. Celle-ci se répand dans notre organisme, ce qui provoque une
réponse immunitaire.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;